import { EventGraphBase, EventGraphNode, EventGraphNodeNotice, EventGraphNodeRender, EventHandlerCmdEnd, EventHandlerGrid, EventHandlerObjectInput, EventHandlerStart, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EventHandlerGenVerticalAxisLine } from "../event-handler/EHGenVerticalAxisLine";
import { EventHandlerDeletVerticalAxisLine } from "../event-handler/EHDeleteVerticalAxisLine";



export class EventGraphGenVerticalAxisLine extends EventGraphBase {

    /**
     * GenVerticalAxisLine指令 用于注册事件图
     */
    static cmd = 'GENVERTICALAXISLINE';

    putInLastCmd: boolean = false

    /**
     * 创建图
     */
    generate() {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "",
                option: 'PARAMS',
                inputTypes: [PythaEventName.OBJECT]
            }]
        });
        const node3 = new EventGraphNode(this, EventHandlerObjectInput);
        const node4 = new EventGraphNode(this, EventHandlerGenVerticalAxisLine);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node8 = new EventGraphNode(this, EventHandlerDeletVerticalAxisLine);
        const node9 = new EventGraphNode(this, EventHandlerGrid);
        const node10 = new EventGraphNodeRender(this, true, UpdateType.ALL);

        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node4, node5);
        this.addEdge(node5, node6);
        this.addEdge(node6, node7);
        this.addEdge(node3, node8);
        this.addEdge(node8, node9);
        this.addEdge(node9, node10);
        this.addEdge(node10, node4);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/138
    }
}